import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getNotifications(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS,
    options
  )
}

function _patchNotificationsMarkAllRead(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_ALL_READ,
    options
  )
}

function _patchNotificationsMarkReadStatus(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_READ_STATUS,
    options
  )
}

function _getNotificationsUnreadCount(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_UNREAD_COUNT,
    options
  )
}

function _getNotification(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION,
    options
  )
}

function _patchNotification(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATION,
    options
  )
}

function _getNotificationPreview(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION_PREVIEW,
    options
  )
}

function _getNotificationsSettings(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_SETTINGS,
    options
  )
}

function _patchNotificationsSettings(options = {}) {
  return _apiRequestWrap(
    ModulesMap.NOTIFICATIONS,
    ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_SETTINGS,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS]: _getNotifications,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_ALL_READ]: _patchNotificationsMarkAllRead,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_READ_STATUS]: _patchNotificationsMarkReadStatus,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_UNREAD_COUNT]: _getNotificationsUnreadCount,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION]: _getNotification,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATION]: _patchNotification,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION_PREVIEW]: _getNotificationPreview,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_SETTINGS]: _getNotificationsSettings,
  [ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_SETTINGS]: _patchNotificationsSettings,
}